var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state),expression:"state"}],staticClass:"qf-loading"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }